module.exports = __webpack_public_path__ + "img/cl.7797825e.svg";